import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_4W_44_4W_7_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_44_4w_7_99_usd',
		},
		primer: 'prd_00Yz1vlhefEJ',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 4,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 28,
		priceMap: {
			USD: 7.99,
		},
		originalPriceMap: {
			USD: 44,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 44,
		},
	},
	options: ($t, product, $tc) => ({
		explicitTermsPeriodText: $tc('common.duration.week.first', 4), // first 4 weeks
		explicitTermsIntervalText: $tc('common.week_plural', 4), // 4 weeks
		billingSubtitlePeriodText: $tc('common.week_plural', 4), // '4 weeks'
		footerPeriodText: $tc('common.duration.week.dashed.lowercase', 4), // '4-week'
		footerIntervalText: $tc('common.duration.week.dashed.lowercase', 4), // '4-week'
	}),
}
